/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const organisationAiSettingsDataSchema = z.object({
	aiPiiEnabled: z.boolean(),
})

export type OrganisationAiSettingsDataSchema = z.infer<typeof organisationAiSettingsDataSchema>
